import {Injectable} from "@angular/core";
import {DeliveryPointRemote} from "@app/core/delivery-point/domain/delivery-point.remote";
import {Observable} from "rxjs";

/**
 * Use case for deleting a delivery point from the user's account.
 */
@Injectable({
    providedIn: 'root'
})
export class DeleteDeliveryPointUseCase {

    constructor(private deliveryPointRemote:DeliveryPointRemote) {
    }

    execute(deliveryPointCode:number): Observable<void> {
        return this.deliveryPointRemote.deleteDeliveryPoint(deliveryPointCode);
    }
}